// extracted by mini-css-extract-plugin
export default {"btn":"ButtonPrimary_btn__zfeA5"};